import api from './api';

const pharmacyService = {
    // Inventory Management
    createInventory: async (data) => {
        const response = await api.post('/pharmacy/inventory', data);
        return response.data;
    },

    getInventory: async () => {
        const response = await api.get('/pharmacy/inventory');
        return response.data;
    },

    getInventoryItem: async (id) => {
        const response = await api.get(`/pharmacy/inventory/${id}`);
        return response.data;
    },

    updateInventory: async (id, data) => {
        const response = await api.put(`/pharmacy/inventory/${id}`, data);
        return response.data;
    },

    deleteInventory: async (id) => {
        const response = await api.delete(`/pharmacy/inventory/${id}`);
        return response.data;
    },

    // Sales Management
    createSale: async (data) => {
        const response = await api.post('/pharmacy/sales', data);
        return response.data;
    },

    getSales: async () => {
        const response = await api.get('/pharmacy/sales');
        return response.data;
    },

    // Return Management
    createReturn: async (data) => {
        const response = await api.post('/pharmacy/returns', data);
        return response.data;
    },

    getReturns: async () => {
        const response = await api.get('/pharmacy/returns');
        return response.data;
    },

    // Purchase Management
    createPurchase: async (data) => {
        const response = await api.post('/pharmacy/purchases', data);
        return response.data;
    },

    getPurchases: async () => {
        const response = await api.get('/pharmacy/purchases');
        return response.data;
    },

    // Expenses Management
    createExpense: async (data) => {
        const response = await api.post('/pharmacy/expenses', data);
        return response.data;
    },

    getExpenses: async () => {
        const response = await api.get('/pharmacy/expenses');
        return response.data;
    },

    // Reports
    getDashboard: async () => {
        const response = await api.get('/pharmacy/report/dashboard');
        return response.data;
    },

    getInventoryReport: async () => {
        const response = await api.get('/pharmacy/report/inventory');
        return response.data;
    },

    getSalesReport: async (startDate, endDate) => {
        const response = await api.get('/pharmacy/report/sales', {
            params: { startDate, endDate }
        });
        return response.data;
    },

    getExpensesReport: async () => {
        const response = await api.get('/pharmacy/report/expenses');
        return response.data;
    },

    // ===== Branch prescription queue (hospital mode) =====
    // status: 'active' (default), 'done', or 'all'
    getPrescriptions: async (status = 'active') => {
        const response = await api.get('/pharmacy/prescriptions', { params: { status } });
        return response.data;
    },

    markPrescriptionDone: async (id) => {
        const response = await api.put(`/pharmacy/prescriptions/${id}/done`);
        return response.data;
    }
};

export default pharmacyService;
